/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetPushingTugVoyageQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetPushingTugVoyageQuery = {
  __typename?: 'Query',
  voyage?: {
    __typename?: 'Voyage',
    id: number,
    voyageNumber: string,
    calls: Array<{
      __typename?: 'Call',
      id: number,
      pta?: number | null,
      ptd?: number | null,
      location: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      },
      linkedChildCalls: Array<{
        __typename?: 'Call',
        id: number,
        weight?: number | null
      }>
    }>
  } | null
};

export type GetPushedBargeVoyagesQueryVariables = Types.Exact<{
  search: Types.PushedBargeVoyageSearch;
  pagination: Types.Pagination;
}>;


export type GetPushedBargeVoyagesQuery = {
  __typename?: 'Query',
  pushedBargeVoyages: {
    __typename?: 'VoyagePage',
    totalElements: number,
    content: Array<{
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      start?: number | null,
      end?: number | null,
      from?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      } | null,
      to?: {
        __typename?: 'Location',
        id: number,
        description: string,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          code?: string | null,
          id: number,
          description: string,
          type: Types.LocationType
        }>
      } | null,
      calls: Array<{
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        ptd?: number | null,
        location: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        }
      }>,
      ship: {
        __typename?: 'Ship',
        id: number,
        name: string
      },
      purchaseCharters?: Array<{
        __typename?: 'PurchaseCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType
      }> | null
    }>
  }
};


export const GetPushingTugVoyageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPushingTugVoyage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voyage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetPushingTugVoyageQuery, GetPushingTugVoyageQueryVariables>;
export const GetPushedBargeVoyagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPushedBargeVoyages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PushedBargeVoyageSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pushedBargeVoyages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetPushedBargeVoyagesQuery, GetPushedBargeVoyagesQueryVariables>;